import clsx from 'clsx'

import { type Period } from 'apps/employer_renewals/types'
import { useBreakpoint } from 'slab'
import { capitalize, cn } from 'utils'

type Props = {
  period: Period
  onPeriodChange: (period: Period) => void
}

const PERIODS: Period[] = ['annual', 'monthly']

export default function PeriodToggle ({ period, onPeriodChange }: Props) {
  const { breakpointIsAtLeast } = useBreakpoint()

  return (
    <div className={clsx('grid grid-cols-2 border border-gray-200 rounded-2xl p-1 min-w-48', {
      'flex-1': !breakpointIsAtLeast('xs'),
    })}
    >
      {PERIODS.map((p) => (
        <button
          key={p}
          className={cn('flex-1 py-2 px-3 rounded-xl body text-center', {
            'border border-thatch-500 bg-thatch-100': p === period,
            'border border-transparent hover:bg-gray-50': p !== period,
          })}
          onClick={() => onPeriodChange(p)}
        >
          {capitalize(p)}
        </button>
      ))}
    </div>
  )
}
